import React, { useEffect, useState } from "react";
import "./topnav.css";
import Popover from "@material-ui/core/Popover";
import { isAuth, signout } from "../../actions/auth";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import NotificationModal from './notification'; // Import your new modal
import Notify from "../customHelpers/Notify";
import Notifications from "../../actions/notification";
import { Avatar, Stack } from "@mui/material";

const Topnav = ({ handleDrawerToggle }) => {
  const history = useHistory();
  const [count, setCount] = useState(parseInt(localStorage.getItem("notificationCount")) || 0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorNotification, setAnchorNotification] = useState(null);

  const fetchNotificationCount = () => {
    const newCount = parseInt(localStorage.getItem("notificationCount")) || 0;
    setCount(newCount);
  };

  useEffect(() => {
    fetchNotificationCount();
    const intervalId = setInterval(() => {
      fetchNotificationCount();
    }, 100); // Fetch every 500 milliseconds

    return () => {
      clearInterval(intervalId);
    };
}, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { NotifyMessage, notify, setNotify } = Notify();

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const[notification,setNotifications] = useState([])
  const {viewAllNotifications} = Notifications()

  const handleCloseNotification = () => {
    setAnchorNotification(null);
  };

  const handleNotificationClick = (event) => {
    setAnchorNotification(event.currentTarget);
    setValues({ ...values, loading: true });
    viewAllNotifications().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.notifications) {
        setValues({
          ...values,
          loading: false,
        });
        setNotifications(data.notifications);
      }
    });
    localStorage.setItem("notificationCount",0)

  };

  const open = Boolean(anchorEl);
  const getInitials = (name) => {
    const nameParts = name?.split(' ');
    if (nameParts?.length < 2) return nameParts[0].charAt(0).toUpperCase();
    return (
      nameParts[0].charAt(0).toUpperCase() + nameParts[1].charAt(0).toUpperCase()
    );
  };
  return (
    <div className="topnav">
      <IconButton className="topnav__MenuIcon" onClick={handleDrawerToggle}>
        <MenuIcon />
      </IconButton>
      {isAuth().role !=="superadmin" &&isAuth()?.staffOrganizations&&
     <span> Organization: {isAuth()?.staffOrganizations[0]?.organization?.organization_name}</span>
}

      <div className="topnav__right">
        <div className="topnav__right-item">
          <div className="dropdown">
          {isAuth().fullName}
            <IconButton
              className="topnav__right-user"
              onClick={() => {
                if(isAuth().role !== "superadmin"){
                history.push("/profile");
              }
              else {
                history.push("/admin/profile");


              }
            }}
            >
              <PersonIcon />
            </IconButton>
            {isAuth().role !== "superadmin" &&
            <IconButton
              className="topnav__right-user"
              aria-label={`show ${count} new notifications`}
              onClick={handleNotificationClick}
            >
            <Badge 
  badgeContent={count > 99 ? `${count}+` : count}
  color="error"
  max={9999} 
>
  <NotificationsIcon />
</Badge>
</IconButton>
}

            <IconButton className="topnav__right-user" onClick={handleClick}>
              <LogoutIcon />
            </IconButton>
            
            <NotificationModal 
              anchorEl={anchorNotification} 
              onClose={handleCloseNotification} 
              notification={notification}
            />

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <div className="topnav__right__dropdown__menu">
                <button
                  onClick={() =>
                    signout(() => {
                      history.replace("/signin");
                    })
                  }
                >
                  <span>Logout</span>
                  <i
                    className="bx bx-log-out-circle"
                    style={{ transform: "rotate(180deg)" }}
                  ></i>
                </button>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topnav;